import React, { useEffect, useMemo } from "react";
import Nav from "../components/Nav/Nav";
import { RightOutlined, LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "../style/Orders.css";

function Orders() {
  const navigate = useNavigate();

  const {
    currentUser,
    ordersClient,
    getOrdersClient,
    isLoading
  } = useAuth();

  useEffect(() => {
    const unsubscribe = getOrdersClient(currentUser?.uid);

    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentUser]);

  const formatDate = (createdAt) => {
    if (!createdAt) return "";

    const date = createdAt?.seconds
      ? new Date(createdAt.seconds * 1000)
      : new Date(createdAt);

    return date.toLocaleDateString("fr-FR");
  };

  const formatAmount = (amount) => {
    return `${(Number(amount || 0) / 100).toFixed(2)} €`;
  };

  const getStatusLabel = (status) => {
    if (status === "paid") return "Payée";
    if (status === "preparing") return "En préparation";
    if (status === "ready") return "Prête";
    if (status === "out_for_delivery") return "En livraison";
    if (status === "delivered") return "Livrée";
    if (status === "completed") return "Terminée";
    if (status === "cancelled") return "Annulée";
    return status || "";
  };

  const getServiceLabel = (order) => {
    switch (order.serviceType) {
      case "table":
        return `À table${order.tableNumber ? ` · Table ${order.tableNumber}` : ""}`;
      case "delivery":
        return "Livraison à domicile";
      case "digital":
        return "Digital";
      case "takeaway":
        return "À emporter";
      default:
        return "";
    }
  };

  const countProducts = (items) => {
    if (!Array.isArray(items)) return 0;
    return items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  };

  const sortedOrders = useMemo(() => {
    return [...ordersClient].filter(
      (order) =>
        order.status !== "pending_payment" &&
        order.status !== "payment_failed"
    );
  }, [ordersClient]);

  return (
    <div className="menu-wrapper">
      <div className="menu-container2">
        <div className="one-page">
          <Nav menu />

          <div className="main">
            <div className="orders-page">
              <div className="order-content">
                <div className="orders-header-inner">
                  <div className="title-back">
                    <h1 className="orders-page-title">Commandes</h1>
                  </div>
                </div>
              </div>

              <div className="order-content">
                {isLoading ? (
                  <div className="orders-loading">
                    <LoadingOutlined spin />
                  </div>
                ) : sortedOrders.length === 0 ? (
                  <div className="orders-empty">
                    <p>Aucune commande</p>
                  </div>
                ) : (
                  <div className="orders-list">
                    {sortedOrders.map((order) => {
                      const productCount = countProducts(order.items);
                      const shortId = order.id?.slice(-3) || order.id;

                      return (
                        <div
                          key={order.id}
                          className="orders-item"
                          onClick={() => navigate(`/orders/${order.id}`)}
                        >
                          <div className="orders-item-left">
                            <p className="orders-item-title">
                              Commande n°{shortId}
                            </p>

                            <p className="orders-item-subtitle">
                              {formatDate(order.createdAt)} · {order.restaurantName || "Restaurant"}
                            </p>

                            <p className="orders-item-meta">
                              {getServiceLabel(order)}
                            </p>

                            <p className="orders-item-meta">
                              {productCount} {productCount > 1 ? "produits" : "produit"} ·{" "}
                              {formatAmount(order.totalAmount || order.amount)} ·{" "}
                              {getStatusLabel(order.status)}
                            </p>
                          </div>

                          <div className="orders-item-right">
                            <RightOutlined />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Orders;